import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { AuthPageLayout } from "@/components/auth/auth-page-layout";
import { LoginForm } from "@/components/login-form";
import { fetchOptionalAuthUser, hydrateAuthUser } from "@/lib/auth-api";
import { safeInternalRedirect } from "@/lib/redirect";

/**
 * `redirect` carries an in-app continuation — the SP-API Login URI bounces a
 * seller here when their session has expired, and the flow must resume at the
 * exact URL Amazon navigated to, Amazon's query parameters intact.
 */
const loginSearchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute("/login")({
  validateSearch: loginSearchSchema,
  beforeLoad: async ({ search }) => {
    const user = await fetchOptionalAuthUser();
    if (user) {
      hydrateAuthUser(user);
      const target = safeInternalRedirect(search.redirect, window.location.origin);
      if (target) throw redirect({ href: target });
      throw redirect({ to: "/" });
    }
  },
  component: LoginPage,
});

function LoginPage() {
  const { redirect: redirectTo } = Route.useSearch();
  return (
    <AuthPageLayout>
      <LoginForm redirectTo={redirectTo} />
    </AuthPageLayout>
  );
}
